export default __webpack_public_path__ + "static/media/adai.a2c7fe01.svg";